import { alpha } from "@mui/material";
const styles = (theme) => ({
	container: { display: "flex", flexDirection: "column", gap: 1, p: 1 },
	boxTitle: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		alignItems: "center",
	},
	titleIcon: { fontSize: "22px", mt: "-2px" },
	deleteIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	boxMapOnus: {
		backgroundColor:
			theme.palette.mode === "dark"
				? alpha(theme.palette.colors.black.dark, 0.4)
				: theme.palette.colors.black.lighter,
		p: 2,
		borderRadius: 4,
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	paperOnuItem: {
		p: 2,
		borderRadius: 4,
		display: "flex",
		flexGrow: 1,
		minHeight: "70px",
	},
	button: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		gap: 4,
		ml: 0,
		mr: 3.5,
		color: theme.palette.text.main,
		borderColor: `${theme.palette.primary.main}42`,
		bgcolor: `${theme.palette.primary.main}10`,
	},
	onuFieldsRow: {
		display: "flex",
		flexWrap: "wrap",
		gap: 1,
		width: "100%",
	},
	onuTextField: {
		flex: "1 1 200px",
		minWidth: 0,
	},
});

export default styles;
